import React, { FC, ReactNode } from 'react';
import { Form, Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';
import { normalizeInputBlockCharacter } from 'src/helpers/common.utils';

export interface INumberInputProps {
	name: string | NamePath | undefined;
	initValue?: string | number | undefined;
	rules?: Rule[];
	placeholder?: string;
	suffix?: ReactNode;
	className?: string;
	noStyle?: boolean;
	disabled?: boolean;
}

const NumberInput: FC<INumberInputProps> = ({ name,noStyle= true, rules, placeholder, ...rest }) => {
	return (
			<Form.Item noStyle={noStyle} name={name} required={false} rules={rules} normalize={normalizeInputBlockCharacter}>
				<Input placeholder={placeholder} {...rest} />
			</Form.Item>
	);
};

export default NumberInput;
